/** Demographic option labels — aligned with Sensemaker target-audience catalog (BFP-252). */

export interface CatalogOption {
  value: string
  label: string
}

export const CHILDREN_OPTIONS: CatalogOption[] = [
  { value: 'none', label: 'None' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5_plus', label: '5+' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const INDUSTRY_OPTIONS: CatalogOption[] = [
  { value: 'technology', label: 'Technology/IT' },
  { value: 'healthcare', label: 'Healthcare/Medical' },
  { value: 'finance', label: 'Finance/Banking' },
  { value: 'education', label: 'Education' },
  { value: 'retail', label: 'Retail/E-commerce' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'construction', label: 'Construction' },
  { value: 'transportation', label: 'Transportation/Logistics' },
  { value: 'energy', label: 'Energy/Utilities' },
  { value: 'telecom', label: 'Telecommunications' },
  { value: 'government', label: 'Government/Public Sector' },
  { value: 'legal', label: 'Legal Services' },
  { value: 'media', label: 'Media/Entertainment' },
  { value: 'hospitality', label: 'Hospitality/Tourism' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'agriculture', label: 'Agriculture/Farming' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'consulting', label: 'Consulting/Professional Services' },
  { value: 'marketing', label: 'Marketing/Advertising' },
  { value: 'nonprofit', label: 'Nonprofit/NGO' },
  { value: 'science', label: 'Science/Research' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'aerospace', label: 'Aerospace/Aviation' },
  { value: 'pharma', label: 'Pharmaceuticals/Biotechnology' },
  { value: 'food_beverage', label: 'Food & Beverage' },
  { value: 'arts', label: 'Arts/Design' },
  { value: 'hr', label: 'Human Resources' },
  { value: 'customer_service', label: 'Customer Service' },
  { value: 'sales', label: 'Sales' },
  { value: 'military', label: 'Military/Defense' },
  { value: 'self_employed_ind', label: 'Self-employed' },
  { value: 'student_ind', label: 'Student' },
  { value: 'unemployed_ind', label: 'Unemployed' },
  { value: 'other_ind', label: 'Other' },
]

export const MARITAL_OPTIONS: CatalogOption[] = [
  { value: 'single', label: 'Single' },
  { value: 'married', label: 'Married' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
  { value: 'domestic_partnership', label: 'Domestic Partnership' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const HOUSING_OPTIONS: CatalogOption[] = [
  { value: 'rent', label: 'Rent' },
  { value: 'own', label: 'Own' },
  { value: 'other', label: 'Other' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const GENDER_OPTIONS: CatalogOption[] = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const EDUCATION_OPTIONS: CatalogOption[] = [
  { value: 'high_school', label: 'High School' },
  { value: 'some_college', label: 'Some College' },
  { value: 'bachelors', label: "Bachelor's Degree" },
  { value: 'masters', label: "Master's Degree" },
  { value: 'doctorate', label: 'Doctorate' },
  { value: 'trade', label: 'Trade or Vocational' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const EMPLOYMENT_OPTIONS: CatalogOption[] = [
  { value: 'full_time', label: 'Employed Full-time' },
  { value: 'part_time', label: 'Employed Part-time' },
  { value: 'self_employed', label: 'Self-employed' },
  { value: 'student', label: 'Student' },
  { value: 'unemployed', label: 'Unemployed' },
  { value: 'retired', label: 'Retired' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export const HOUSEHOLD_OPTIONS: CatalogOption[] = [
  { value: '1', label: 'Just Me' },
  { value: '2', label: '2 People' },
  { value: '3', label: '3 People' },
  { value: '4', label: '4 People' },
  { value: '5', label: '5 People' },
  { value: '6', label: '6 People' },
  { value: '7_plus', label: '7+ People' },
  { value: 'prefer_not', label: 'Prefer not to say' },
]

export { US_STATE_OPTIONS, CITIES_BY_STATE } from './usLocationCatalog'

export const STEP_FIELD_ERRORS: Record<string, string> = {
  numberOfChildren: 'Please select number of children',
  industry: 'Please select your industry or field of work',
  maritalStatus: 'Please select your marital status',
  housingStatus: 'Please select your housing status',
  default: 'This field is required',
}
